import { useParams } from 'react-router-dom';
import { React, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';



const Meet_Jump_Screen = (params) => {
    const { t } = useTranslation();
    const { url } = useParams();

    const moves = [];
    let lastMove = new Date();

    useEffect(() => {
        (async () => {
            setTimeout(() => {
                //window.$("#meet_link").click();
            }, 1000);

            window.$(window.document).on("mousemove", (e) => {
                moves.push({ x: e.pageX, y: e.pageY, time: new Date().getTime() - lastMove.getTime() });
                lastMove = new Date();
            });
        })();
    }, []);

    return (<div>
        <input id="c3" class="form-control" autoFocus={true} type="text"></input>
        <button onClick={(e) => {
            alert("click!");
        }}>{t('button', { ns: 'labels' })}</button>
        <a href={url} id="meet_link" target="_blank">{url}</a>
    </div>)
}

export { Meet_Jump_Screen }